import React from "react";
import Typed from "react-typed";
import { Link } from "react-scroll";
const Header = () => {
  return (
    <div id="home" className="header-wraper">
      <div className="main-info">
        <h1
          className="welcome"
          style={{ fontSize: 20, textTransform: "lowercase", padding:"2.5rem" }}
        >
          “How many programmers does it take to change a light bulb? None,
          that’s a hardware problem.”
        </h1>
        <Typed
          className="typed-text"
          strings={[
            "web design",
            "MERN stack web development",
            "MySQL",
            "API Interaction",
          ]}
          //    this speed is for when writing up
          typeSpeed={30}
          // speed for deleting
          backSpeed={40}
          // this will loop the array without stoping
          loop
        />
        <Link smooth={true} to="contact" href="#" className="contact-button">
          {" "}
          contact me
        </Link>
        <a
          href="https://drive.google.com/file/d/1HeduBcc0mJHD1jiMoP-6zMlRpSv8XyDw/view?usp=sharing"
          target="_blank"
          rel="noreferrer"
          className="contact-button"
        >
          {" "}
          Resume{" "}
        </a>
      </div>
    </div>
  );
};

export default Header;
